import React from 'react';
import { Success } from './styles/contactModalStyles';

const FormSuccess = () => {
    return (
        <Success>
            <p>Sucessfully Sent Email!</p>
        </Success>
    )
}

export default FormSuccess
